import React from 'react';
import {Form} from 'react-bootstrap';
import {ControlledInput} from '../../interfaces/Forms';
import clsx from 'clsx';

interface DateInputControlledProps {
    value?: string;
    min?: string;
    max?: string;
}

const DateInputControlled = ({
    name,
    value,
    label,
    disabled,
    onChange,
    onBlur,
    onReset,
    touched,
    errors,
    min,
    max,
}: ControlledInput & DateInputControlledProps): JSX.Element => {
    return (
        <div>
            <Form.Group style={{width: 'fit-content'}}>
                <Form.Label className="fw-bold fs-3 required">{label}</Form.Label>
                <Form.Control
                    name={name}
                    value={value}
                    className={clsx(
                        {'is-invalid': touched && errors},
                        {'is-valid': touched && !errors}
                    )}
                    type="datetime-local"
                    onChange={onChange}
                    onBlur={onBlur}
                    onReset={onReset}
                    min={min || undefined}
                    max={max ?? undefined}
                    disabled={disabled}
                />
                {touched && errors && (
                    <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                            <span role="alert">{errors}</span>
                        </div>
                    </div>
                )}
            </Form.Group>
        </div>
    );
};

export default DateInputControlled;
